import { useEffect, useState } from 'react'
import { ToolPageShell } from '@/shared/seo'
import { SzhatForm } from './SzhatForm'
import {
  resolveCompressionEntry,
  type CompressionEntry,
} from './targetPreset'

export function SzhatPage() {
  const [entry, setEntry] = useState<CompressionEntry>({
    targetPreset: 'none',
    landingSource: 'direct',
  })

  useEffect(() => {
    setEntry(resolveCompressionEntry(window.location.search))
  }, [])

  return (
    <ToolPageShell utilityKey="szhat">
      <SzhatForm
        initialTargetPreset={entry.targetPreset}
        initialLandingSource={entry.landingSource}
      />
    </ToolPageShell>
  )
}
